export const dashboardConstants = {
  SET_CHARTS_SUCCESS: 'SET_CHARTS_SUCCESS',
  SET_CHARTS_FAILURE: 'SET_CHARTS_FAILURE',

  SET_SUMMARY_SUCCESS: 'SET_SUMMARY_SUCCESS',
  SET_SUMMARY_FAILURE: 'SET_SUMMARY_FAILURE',

  SET_DASHBOARD_REFERRAL_STATS_SUCCESS: 'SET_DASHBOARD_REFERRAL_STATS_SUCCESS',
  SET_DASHBOARD_REFERRAL_STATS_FAILURE: 'SET_DASHBOARD_REFERRAL_STATS_FAILURE',
};
